<template>

  <div class="mt-5">
    <label>Roles:</label>
    <ul class="mt-3 pl-3">
      <li class="mb-2">
        <vs-checkbox v-model="data.member">Member</vs-checkbox>
      </li>
      <li class="mb-2">
        <vs-checkbox color="warning" v-model="data.staff">Staff</vs-checkbox>
      </li>
      <li class="mb-2">
        <vs-checkbox color="#24c1a0" v-model="data.marketing">Marketing</vs-checkbox>
      </li>
      <li class="mb-2">
        <vs-checkbox color="danger" v-model="data.admin">Admin</vs-checkbox>
      </li>
    </ul>
  </div>

</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => { return {} }
    }
  }
}
</script>
